import { render, staticRenderFns } from "./JifenItem.vue?vue&type=template&id=64057751&scoped=true"
import script from "./JifenItem.vue?vue&type=script&lang=js"
export * from "./JifenItem.vue?vue&type=script&lang=js"
import style0 from "./JifenItem.vue?vue&type=style&index=0&id=64057751&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64057751",
  null
  
)

export default component.exports